import { AccountButton } from "@ssf/auth-components";
import { AppHeader, TraditionalClubLogo } from "@ssf/components";
import { useTranslation } from "react-i18next";

import { routes } from "../lib/routes.js";

export const Header = () => {
  const { t } = useTranslation("TraditionalClubs", { keyPrefix: "Header" });

  return (
    <AppHeader
      logo={<TraditionalClubLogo />}
      title={t("title")}
      to={routes.selectClub}
    >
      <AccountButton />
    </AppHeader>
  );
};
